import { SeedingBacterium } from 'components';
import { ProcessedBacteriaData } from 'services/seeding/seedingResponses';

export const SeedingBacteriaList = ({
  data,
  transferredFromBirthMother,
}: {
  data: ProcessedBacteriaData[];
  transferredFromBirthMother?: boolean;
}) => {
  let bacterialist = data.map((bacterium, i) => {
    return (
      <SeedingBacterium
        key={bacterium.id || i}
        bacterium={bacterium}
        transferredFromBirthMother={transferredFromBirthMother}
      />
    );
  });
  return bacterialist;
};
